import Input from './Input';
import Stack from './Stack';

function AddressForm({ address, handleChange }) {
  const fields = [
    { placeholder: 'City', name: 'city' },
    { placeholder: 'State', name: 'state' },
    { placeholder: 'Zip Code', name: 'zip' },
  ];

  return (
    <Stack width="full" justify="center" align="center" gap="4">
      <Input
        name="street"
        placeholder="Street Address"
        value={address.street}
        onChange={handleChange}
      />
      <div className="flex sm:flex-row flex-col gap-4 w-full">
        {fields.map(({ placeholder, name }) => (
          <Input
            key={name}                 // stable
            name={name}
            placeholder={placeholder}
            value={address[name]}
            onChange={handleChange}
          />
        ))}
      </div>
    </Stack>
  );
}

export default AddressForm;
